import { yupResolver } from '@hookform/resolvers/yup'
import { SubmitHandler, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import FieldV2 from 'src/components/FormComponents/FieldV2'
import FieldDropdownV2 from 'src/components/FormComponents/FieldDropdownV2'
import Form from 'src/components/FormComponents/Form'
import Submit from 'src/components/FormComponents/Submit'
import { selectFulfillmentCenters } from 'src/features/selector'
import { FulfillmentCenter } from 'src/features/types'
import { formatOnlyNumberOnInput } from 'src/utils/formatInput'
import { actions } from '../../StockListState'
import { StockListFilters } from '../../StockListTypes'
import { defaultFCValue } from './StockForm.data'
import { schema } from './StockForm.schema'
import * as S from './StockForm.styles'
import { useSelector as storeUseSelector } from 'src/utils/store'
import { useEffect } from 'react'
import { actions as appActions } from 'src/features/state'
import { defaultFulfillmentCenterTypeFilters } from 'src/features/fulfillmentCenterFilters'

export default () => {
  const { filters: stateFilters } = storeUseSelector((state) => state.stockList)

  const {
    control,
    handleSubmit,
    setValue,
    reset,
  } = useForm<StockListFilters>({
    resolver: yupResolver(schema),
  })

  useEffect(() => {
    setValue('fulfillmentCenterId', stateFilters.fulfillmentCenterId)
    if (stateFilters.modelId !== 0) {
      setValue('modelId', stateFilters.modelId)
    }
    setValue('code', stateFilters.code)
    setValue('barcode', stateFilters.barcode)
    setValue('description', stateFilters.description)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const dispatch = useDispatch()
  const fcs = useSelector(selectFulfillmentCenters)

  useEffect(() => {
    dispatch(appActions.getAvailableFulfillmentCenters(defaultFulfillmentCenterTypeFilters))
  }, [dispatch])

  const onSubmit: SubmitHandler<StockListFilters> = (filters) => {
    dispatch(actions.setFilters(filters))
    dispatch(actions.clearStock())
    dispatch(actions.resetPage())
    dispatch(actions.getStock())
  }

  const clearFilters = () => {
    dispatch(actions.clearFilters())
    reset()
    setValue('fulfillmentCenterId', defaultFCValue)
  }

  const prepareFcs = (_fcs: FulfillmentCenter[]) => {
    const options = _fcs.map((fc) => ({ value: fc.id, label: fc.name }))
    return [{ value: defaultFCValue, label: 'Todos' }, ...options]
  }

  return (
    <S.Form as={Form} onSubmit={handleSubmit(onSubmit)}>
      <S.Field
        as={FieldDropdownV2}
        labelText='Fulfillment Center'
        name='fulfillmentCenterId'
        defaultValue={stateFilters.fulfillmentCenterId ? stateFilters.fulfillmentCenterId.toString() : defaultFCValue.toString()}
        control={control}
        options={prepareFcs(fcs)}
      />
      <S.Field
        as={FieldV2}
        type='number'
        labelText='ID Modelo'
        name='modelId'
        onInput={formatOnlyNumberOnInput}
        control={control}
        testId='model-id-input-test-id'
      />
      <S.Field
        as={FieldV2}
        labelText='Cód. produto'
        name='code'
        control={control}
        testId='code-input-test-id'
      />
      <S.Field
        as={FieldV2}
        labelText='Código de barras'
        name='barcode'
        control={control}
        testId='barcode-input-test-id'
      />
      <S.Field
        as={FieldV2}
        labelText='Descrição do produto'
        name='description'
        control={control}
        testId='description-input-test-id'
      />
      <S.Submit as={Submit} disabled={false} text='Buscar' testId='search-button-test-id'/>
      <S.Button type='button' onClick={clearFilters} data-testid='clear-button-test-id'>Limpar</S.Button>
    </S.Form>
  )
}
